import { Hamburger, SpanBtn } from "../atoms";

export const HamburgerBtn = ({ onClick, customClasses, childHamClasses }) => {
  return (
    <SpanBtn customClasses={customClasses} onClick={onClick}>
      <Hamburger customClasses={childHamClasses} />
    </SpanBtn>
  );
};
